<template>

<Modal @close="closeModale">
    <template #header>
        برداشت {{$coins[relatedCoin].persianName}}
    </template>
    <template #body >
                      <template>
                <label for="" class="selectd-net-lable">
                    <div class="selectd-net" @click="drop = !drop">
                        <span v-if="selected_net">{{selected_net}}</span>
                        <span v-else>انتخاب شبکه</span>
         
                    </div>
                                   <p v-if="!selected_net">لطفا برای ادامه ی واریز شبکه ی مورد نظر را  انتخاب کنید</p>
                    <div class="dropdown" v-if="drop">
                        <div v-for="(net , index) in nets" :key="index" @click="selectFun(index)">
                            {{net.tokenType}}
                        </div>
                    </div>
                    
                </label>
               
            </template>



           <div class="body" v-if="selected_net">
                <p class="text"> در ﺻﻮرت ﺗﻤﺎﯾﻞ ﺑﻪ ﺑﺮداﺷﺖ ﻣﻮﺟﻮدی کیف ﭘﻮل‌ﻫﺎی ﺧﻮد، درﺧﻮاﺳﺖ ﺧﻮد را اﯾﻨﺠﺎ ﺛﺒﺖ ﻧﻤﺎﯿﯾﺪ. درﺧﻮاﺳﺖ‌ﻫﺎ ﺑﻪ ﺻﻮرت دﺳﺘﯽ تایید و ﺳﭙﺲ ﭘﺮداﺧﺖ ﺧﻮاﻫﻨﺪ ﺷﺪ. ﮐﺎرﻣﺰدﻫﺎی ﻣﻌﻤﻮل اﻧﺘﻘﺎل از ﻣﺒﻠﻎ ﺑﺮداﺷﺖ ﮐﺴﺮ ﺧﻮاﻫﺪ ﺷﺪ. در صورتی که آدرس ﻣﻘﺼﺪ ﻣﺘﻌﻠﻖ ﺑﻪ ﮐﺎرﺑﺮان دریک ﺑﺎﺷﺪ اﻧﺘﻘﺎل ﺑﻪ ﺻﻮرت ﻣﺴﺘﻘﯿﻢ و آﻧﯽ ﺻﻮرت می گیرد و ﮐﺎرﻣﺰد اﻧﺘﻘﺎل ﺻﻔﺮ ﺧﻮاﻫﺪ ﺑﻮد.</p>
              <div class="points" >
                <div class="point">
                  <div class="point-label"><img src="../../../assets/icon/caution.svg"/>کارمزد  شبکه</div>
                 {{ wage }}
                </div>
                <div class="point">
                  <div class="point-label"><img src="../../../assets/icon/caution.svg"/>حداقل میزان برداشت</div>
                  <div dir="ltr">{{ min  }}   {{ $coins[relatedCoin].code }} </div>
                </div>
        <div class="point">
                  <div class="point-label"><img src="../../../assets/icon/caution.svg"/>حداکثر میزان برداشت</div>
                  <div dir="ltr">{{ max  }}   {{ $coins[relatedCoin].code }} </div>
                </div>
              </div>

             <div class="depsoit"><div class="depsoit-label">موجودی  </div> <div class="depsoit-value">  {{$toLocal($S2N(cash), 3)}}    {{ $coins[relatedCoin].code }}</div></div>

              <div class="inputs-container">
                <label-input :label="' میزان برداشت '+' ('+$coins[relatedCoin].code+')'" @value="value=> amount = value"   @input="amount = $toLocal(amount)" 
          v-model="amount" />
                <label-input  label=" آدرس کیف پول مقصد " v-model="walletAddress"  @value="value=> walletAddress = value" />
                <label-input  label=" شناسه دو عاملی " v-if="continu" @value="value=> code = value"  />
                  <div class="timer" v-if="continu"> {{countDown}}</div>
              </div>
             <!-- <button  @click="$emit('modalToggle','')">ثبت</button> -->

               <button v-if="otpInput && countDown!==0" class="cont" @click="submitWithdrawRequest" :disabled="!! disabled ">
                <!-- v-if="otpInput && countDown!==0" -->
                برداشت
            </button>
            <button v-if="otpInput===false" class="cont" @click="withdraw" :disabled="!!disabled">
                <!-- v-if="otpInput===false && countDown==0" -->
                <span v-if="!!disabled">{{disabled}}</span>
                      <span v-else> ارسال کد تایید</span>
            </button>
            <button v-if="otpInput===true && countDown===0" class="submit" @click.prevent="send">
                ارسال مجدد
            </button>

           </div>
    </template>

</Modal>
  
</template>

<script>
import Modal from './Modal'
export default {
  name: 'CryptoWithdarw',
  components:{
      Modal,
  },
  props:{
      crypto:Object,
        relatedCoin: {
      default: "",
    },
    cash: {
      default: 0,
    },
    wage: {
      default: 0,
    },
    role: {
      default: {},
    },
    exchange: {
      default: false,
    },
    nets: {
      default: [],
    },
  },
    data() {
    return {
      closeIt: true,
      continu: false,
      submit: false,
      success: false,
      amount: "",
      walletAddress: "",
      local: false,
      token: false,
      transaction: {
        amount: "",
        destinationWalletAddress: "",
        relatedCoin: "",
        tokenType: "",
        code: "",
        walletType: this.exchange ? "EXCHANGE" : "P2P",
      },
      towStepAuthenticationType: "",
      otpInput: false,
      counter: false,
      timeOut: "",
      countDown: 120,
      code: "",
      selected_net: "",
      txIdIsNeeded: false,
      drop: false,
      enable: false,
    };
  },
  computed: {
    disabled() {
      let Errors= ''
      if(!this.selected_net){
        Errors = 'انتخاب شبکه'
      }
else if(!this.$S2N(this.amount) ){
  Errors = "مقدار برداشت را وارد کنید"
}

else if(this.$S2N(this.amount) > this.$S2N(this.cash) ){
  Errors="مقدار برداشت بیشتر از موجودی کیف پول است"
}
else if(this.$S2N(this.amount) > this.$S2N(this.max)){
  Errors = "مقدار برداشت بیشتر از حداکثر میزان برداشت می باشد"
}
else if( this.$S2N(this.amount) < this.$S2N(this.min)){
  Errors = "مقدار برداشت کمتر از حداقل میزان برداشت می باشد"
}
else if(!this.walletAddress){
  Errors= "آدرس کیف پول مقصد را وارد کنید"
}
      // return (
      //   !this.$S2N(this.amount) ||
      //   !this.walletAddress ||
      //   this.$S2N(this.amount) > this.$S2N(this.cash) ||
      //   this.$S2N(this.amount) > this.$S2N(this.max) ||
      //   this.$S2N(this.amount) < this.$S2N(this.min)
      // );
      return Errors
      // ( !this.enable )
      // (!this.selected_net)
    },
    // min() {
    //   return this.role.;
    // },
    // max() {
    //   return this.role.maxWithdrawAmount;
    // },
    danger() {
      return (
        "حداقل " +
        this.$toLocal(this.min) +
        " " +
        this.$coinLabel[this.relatedCoin] +
        "\n" +
        "حداکثر " +
        this.$toLocal(this.max) +
        " " +
        this.$coinLabel[this.relatedCoin]
      );
    },
  },
  methods: {
    countDownTimer() {
      this.continu=true;
      if (this.countDown > 0) {
        this.timeOut = setTimeout(() => {
          this.countDown--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error("زمان شما به اتمام رسید", "");
      }
    },
    closeModale() {
      this.$emit("closeModaleEmit");
    },
    async withdraw() {
      if (!this.disable && !this.state.loading) {
        this.state.loading = true;
        (this.transaction.amount = this.$S2N(this.amount)),
          (this.transaction.destinationWalletAddress = this.walletAddress),
          (this.transaction.relatedCoin = this.relatedCoin);
        if ("TETHER" === this.relatedCoin) {
          this.transaction.tokenType = this.token ? "ERC20" : "TRC20";
        }
        const res = await this.$axios.post("/users/send-code");
        this.towStepAuthenticationType = res.baseDTO.towStepAuthenticationType;
        this.otpInput = true;
        if (this.towStepAuthenticationType !== "GOOGLE_AUTHENTICATOR") {
          this.counter = true;
          this.countDownTimer();
        }
      }
    },
    async send() {
            this.state.loading = true;
      this.code = "";

      const a = {
        EMAIL: "ایمیل",
        SMS: "شماره",
      };
      const res = await this.$axios.post("/users/send-code");
      this.towStepAuthenticationType = res.baseDTO.towStepAuthenticationType;
      if (res.message === "Verification Code Sent") {
        this.$error(
          "",
          "کد به " + a[this.towStepAuthenticationType] + " شما ارسال شد",
          "success"
        );
        if (this.countDown === 0) this.countDown = 120;
        this.countDownTimer();
        this.state.loading = false;
      }
    },
    selectFun(index) {
      console.log()
      this.selected_net = this.nets[index].tokenType;
      this.transaction.tokenType = this.selected_net;
      this.txIdIsNeeded = this.nets[index].txIdIsNeeded;
      this.enable = this.nets[index].withdrawEnable;
      this.wage = this.nets[index].withdrawalFee
      this.min = this.nets[index].minWithdraw
      this.max = this.nets[index].maxWithdraw
      this.drop = false;
    },
    async submitWithdrawRequest() {
      this.state.loading = true;
      this.transaction.code = this.code;
      const [res] = await this.$http.post(
        "/wallets/withdrawal-request",
        this.transaction
      );
      if (res) {
        this.$emit("closeModaleEmit");
        this.$error("درخواست شما با موفقیت ثبت شد", "", "success");
        ++this.state.requestChanged;
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.selectd-net-lable {
    position: relative;
    z-index: 2;
display: flex;
flex-direction: column;
    .selectd-net {
        cursor: pointer;
        background: transparent;
          border: 1px solid #279bc0;
    border-radius: 4px;
        height: 38px;
        width: 100%;
        color: var(--font-strong);
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        
        align-items: center;
    }

    .dropdown {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-self: center;
        position: absolute;
        width: 90%;
        top: 48px;
        background: #001E3D !important;
            border: 1px solid #279bc0;
    border-radius: 4px;
        padding: 10px;

        div {
            cursor: pointer;
        }
    }
}
.depsoit{
  color: #D7C8C8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 15px;

}
.points{
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

button{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  width: 100%;
  color: white;
  padding: 8px 0px;
}
.depsoit-value{
  display: flex;
  column-gap: 5px;
  direction: ltr;
  font-size: clamp(11px,1.2vw,12px);
  cursor: pointer;
}
.depsoit-label{
  font-size: clamp(9px,1vw,10px);
}
.body{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.inputs-container{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.point{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: clamp(12px,1.3vw,14px);
}

.point-label{
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.text{
  font-size: clamp(13px,1.4vw,16px);
}
</style>
